import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { DraftContent, IconArrowHead } from '../../components';
import LandscapeCard from './LandscapeCard/LandscapeCard';
import css from './ListingPage.module.css';

const SectionRewildingEfforts = props => {
  const { publicData = {}, locale, rewildingLandscapes, listingTranslation } = props;

  const {
    listing_rewildingsuppportstay,
    listing_rewildingsuppportexp,
  } = publicData;

  const currentLandscapeID = publicData?.field_landscape;

  if (!listing_rewildingsuppportstay && !listing_rewildingsuppportexp && !currentLandscapeID) {
    return null;
  }

  const [showSection, setShowSection] = useState(true);

  const isStay = Boolean(listing_rewildingsuppportstay);

  const messageId = isStay
    ? 'ListingPage.stayRewildingEfforts'
    : 'ListingPage.experienceRewildingEfforts';

  const fieldName = isStay
    ? 'listing_rewildingsuppportstay'
    : 'listing_rewildingsuppportexp';

  const fallbackDescription = isStay
    ? listing_rewildingsuppportstay
    : listing_rewildingsuppportexp;

  const content =
    listingTranslation?.[`${fieldName}_locale_${locale}`] || fallbackDescription;

  const landscape = rewildingLandscapes?.find(b => currentLandscapeID?.indexOf(b.blockId) !== -1);

  return (
    <section className={css.section}>
      <h2 className={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <FormattedMessage id={messageId} />
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </h2>
      {showSection && (
        <>
          {content && <DraftContent draftContent={content} />}
          {!!currentLandscapeID && (
            <LandscapeCard landscape={landscape} />
          )}
        </>
      )}
    </section>
  );
};

export default SectionRewildingEfforts;